<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!--      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>-->
      <el-breadcrumb-item>系统功能</el-breadcrumb-item>
      <el-breadcrumb-item>项目列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!--    <el-button type="primary" class="btn-add"  v-if="$store.getters['right/hasRight']('projectList:createProject')" @click="showAddProjectDialog"-->
    <!--    >创建项目-->
    <!--    </el-button>-->
    <el-button type="primary" class="btn-add" @click="exportProjectInfo" plain
               v-if="$store.getters['right/hasRight']('projectList:exportProject')">导出项目信息表
    </el-button>
    <!-- 主体部分 -->
    <template>
      <el-card class="box-card">
        <div>
          <search-sort-tag :sortList="sortList" :searchConditionTag="searchConditionTag" @deleteSelect="deleteSelect"
                           @deleteSort="deleteSort"></search-sort-tag>
          <div class="table-container">
            <a-config-provider :locale="locale">
              <a-table :data-source="project.projectData" :columns="columns"
                       :rowKey="(record) => record.projectsRow.projectId"
                       bordered
                       @change="changeTable" :pagination="false"
                       :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                       :scroll="{x:'max-content'}">
                <span slot="customProject" slot-scope="text, record">
<!--                  <span v-if="$store.getters['right/getRole']==='auditor'">{{ text }}</span>-->
                  <span v-if="$store.getters['right/hasRight']('project:noComeAnalyze')">{{ text }}</span>
                  <a v-else href="#" @click.prevent="toProject(text)">{{ text }}</a>
                </span>
                <span slot="customCategory" slot-scope="text, record">
                 <span>
                   <el-tooltip content="修改类型">
               <i class="el-icon-edit" style="color: green;cursor: pointer" @click="handleShowUpdateDialog(record)"></i>
                 </el-tooltip>{{ text }} </span>
                </span>
                <div slot="customNote" slot-scope="text, record">
                  <div style="display: flex;align-items: center">
                    <el-tooltip content="修改备注">
                      <i class="el-icon-edit" style="color: green;cursor: pointer" @click="editNote(record)"></i>
                    </el-tooltip>
                    <div>
                <span v-html="computerNote(text)">
                </span>
                      <el-tooltip content="显示更多信息">
                        <span v-if="showNote(text)" @click="editNote(record)" style="font-size: 11px;cursor: pointer">......</span>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
                <div slot="rawdataStatus" slot-scope="text, record">
                  <el-tag v-if="text" type="success" round size="mini" effect="dark"
                          style="width: 80px;height: 28px;text-align: center;padding-top: 4px">已释放
                  </el-tag>
                  <el-tag v-else type="info" round size="mini" effect="dark"
                          style="width: 80px;height: 28px;text-align: center;padding-top: 4px">未释放
                  </el-tag>
                </div>
                <div slot="filterType" slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters }"
                     style="padding: 8px; position: relative; z-index: 9999 !important;">
                  <div style="padding: 0px 15px">
                    <el-radio-group v-model="selectedKeys[0]">
                      <div style="display: flex">
                        <el-radio label="未释放">未释放</el-radio>
                        <el-radio label="已释放">已释放</el-radio>
                      </div>
                    </el-radio-group>
                  </div>
                  <div style="display: flex;padding: 15px">
                    <a-button
                      type="primary"
                      icon="search"
                      size="small"
                      style="width: 90px; margin-right: 8px"
                      @click="() => handleSearch(setSelectedKeys,selectedKeys, confirm, column,clearFilters)">搜索
                    </a-button>
                    <a-button size="small" style="width: 90px" @click="() => handleReset( column,clearFilters)">取消
                    </a-button>
                  </div>
                </div>
                <div slot="operation" slot-scope="text, record" v-has-role="['manager','auditor','analyzer']">
                  <el-button plain v-if="$store.getters['right/hasRight']('project:changeUser')"
                             type="warning" size="mini" @click="handleEditProject(record)">更改用户
                  </el-button>
                  <el-button plain v-if="$store.getters['right/hasRight']('project:delete')"
                             type="danger" size="mini" @click="handleDeleteProject(record)">删除
                  </el-button>
                  <!--                  <el-popconfirm-->
                  <!--                    confirm-button-text='同意释放'-->
                  <!--                    cancel-button-text='取消'-->
                  <!--                    icon-color="#d07b7b"-->
                  <!--                    title="你同意释放该项目的原始数据吗？"-->
                  <!--                    @confirm="releaseRowData(record)"-->
                  <!--                    @cancel="releaseRowDataNo(record)"-->
                  <!--                  >-->
                  <!--                    <el-button-->
                  <!--                      v-if="($store.getters['right/getRole']==='manager'||$store.getters['right/getRole']==='auditor')&&!record.projectsRow.rawdataStatus"-->
                  <!--                      type="primary" size="mini" plain-->
                  <!--                      slot="reference" style="margin-left: 10px;">释放数据-->
                  <!--                    </el-button>-->
                  <!--                  </el-popconfirm>-->
                </div>
                <div
                  slot="filterDropdown"
                  slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters }"
                  style="padding: 8px">
                  <a-input
                    v-ant-ref="c => (searchInput = c)"
                    :placeholder="`搜索 ${column.title}`"
                    v-model="selectedKeys[0]"
                    style="width: 188px; margin-bottom: 8px; display: block;"
                    @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                    @pressEnter="() => handleSearch(setSelectedKeys,selectedKeys, confirm, column,clearFilters)"/>
                  <a-button
                    type="primary"
                    icon="search"
                    size="small"
                    style="width: 90px; margin-right: 8px"
                    @click="() => handleSearch(setSelectedKeys,selectedKeys, confirm, column,clearFilters)">
                    搜索
                  </a-button>
                  <a-button size="small" style="width: 90px" @click="() => handleReset( column,clearFilters)">
                    取消
                  </a-button>
                </div>
                <div
                  slot="time"
                  slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters }"
                  style="padding: 8px">
                  <a-date-picker
                    v-model="selectedKeys[0]"
                    placeholder="起始时间：xx/xx/xx/"
                    style="width: 188px; margin-bottom: 8px; display: block;"/>
                  <a-date-picker
                    v-model="selectedKeys[1]"
                    placeholder="结束时间：xx/xx/xx/"
                    style="width: 188px; margin-bottom: 8px; display: block;"/>
                  <a-button
                    type="primary"
                    icon="search"
                    size="small"
                    style="width: 90px; margin-right: 8px"
                    @click="() => handleSearch(setSelectedKeys,selectedKeys, confirm, column,clearFilters)">
                    搜索
                  </a-button>
                  <a-button size="small" style="width: 90px" @click="() => handleReset(column,clearFilters)">
                    取消
                  </a-button>

                </div>
                <a-tooltip placement="topLeft" title="搜索" slot="filterIcon" slot-scope="filtered">
                  <a-icon
                    type="filter"
                    :style="{ color: filtered ? '#108ee9' : undefined,title:'搜索'}"/>
                </a-tooltip>
              </a-table>
            </a-config-provider>
          </div>
          <br>
          <pagination :child-msg="projectPageChildMsg" @callFather="handlePagePagination"></pagination>
        </div>

      </el-card>

    </template>

    <el-dialog :destroy-on-close="true"
               title="编辑信息"
               :visible.sync="showUpdateDialog"
               width="500px">
      <el-form :model="updateProjectData" ref="updateProjectInfoForm" label-width="70px">
        <el-form-item label="类型">
          <el-input v-model="updateProjectData.category" placeholder="请输入类型"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
              <el-button @click="showUpdateDialog = false">取 消</el-button>
              <el-button type="primary" @click="updateProject">确 定</el-button>
            </span>
    </el-dialog>
    <el-dialog :destroy-on-close="true"
               title="备注信息"
               :visible.sync="showNoteDialog"
               width="500px">
      <el-form :model="updateProjectData" label-width="70px">
        <el-form-item label="备注">
          <el-input type="textarea" v-model="updateProjectData.note" maxlength="100"
                    placeholder="请输入备注内容" show-word-limit rows="4" @input="limitLength"></el-input>
          <span style="color: red" v-if="exceedMax">字数已达上限</span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
                  <el-button @click="showNoteDialog = false">取 消</el-button>
                  <el-button type="primary" @click="updateProject">确 定</el-button>
          </span>
    </el-dialog>
    <el-dialog :destroy-on-close="true"
               title="更改项目关联用户"
               :visible.sync="showUserDialog"
               width="500px">
      <el-form :model="updateProjectUserData" label-width="120px">
        <el-form-item label="分析人员">
          <el-select v-model="updateProjectUserData.selectedAnalyze" filterable placeholder="请选择">
            <el-option
              v-for="(item,index) in analyzerList"
              :key="index"
              :label="item.userName"
              :value="item.userId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="销售">
          <el-select v-model="updateProjectUserData.selectedSalers" filterable multiple placeholder="请选择">
            <el-option
              v-for="(item,index) in salerList"
              :key="index"
              :label="item.userName"
              :value="item.userId">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
              <el-button @click="showUserDialog = false">取 消</el-button>
              <el-button type="primary" @click="updateProjectUser">确 定</el-button>
      </span>

    </el-dialog>
    <my-progress/>
    <!--    图片，加载中-->
    <picture-loading v-if="loadingProject"></picture-loading>
    <!--    xx新建中-->
    <LoadingDialog v-if="isShowAddLoading" :showDialog="isShowAddLoading"
                   :dialogMessage="showAddLoadingMess"></LoadingDialog>
    <!--    添加项目-->
    <add-project v-if="addProjectDialogVisible" :show-dialog="addProjectDialogVisible"
                 @submit="addProject"></add-project>
  </div>
</template>


<script>
import Pagination from '@/components/Pagination'
import {checkPhoneOrEmptyRule, checkNameOrEmptyRule, DataConvert, addT, fileDownload, checkMail} from '@/utils/utils'
import Upload from '@/components/Upload'
import MyProgress from '@/components/Progress'
import {decrypt, encrypt} from '@/utils/CryptoJSUtils'

import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import PictureLoading from "@/components/PictureLoading";
import {fastaSize, picrustSize, sampleSize, treeSize, zipSize} from '@/utils/uploadFileSize'
import {checkMd5} from "@/utils/burstUpload";
import LoadingDialog from "@/components/LoadingDialog";
import {myMixins} from "@/mixins/tableOperation";
import SearchSortTag from "@/components/SearchSortTag";
import {getDataInSessionStorage, removeDataInSessionStorage, saveDataToSessionStorage} from "@/utils/sessionStorage";
import {userTransDown, userTransUp} from "@/utils/user";
import {getDataInLocalStorage} from "@/utils/localStorageUtils";
import AddProject from "@/components/AddProject";
const baseURL = process.env.VUE_APP_BASE_API
export default {
  mixins: [myMixins],
  components: {
    AddProject,
    LoadingDialog,
    PictureLoading,
    'pagination': Pagination,
    'upload': Upload,
    'my-progress': MyProgress,
    'search-sort-tag': SearchSortTag
  },
  data() {
    return {
      addProjectDialogVisible: false,//新增项目
      isShowAddLoading: false,//新建项目中的弹框
      showAddLoadingMess: '',//新建项目中的信息
      showNoteDialog: false,//修改备注信息弹框
      showUserDialog: false,//更换用户弹框
      exceedMax: false,//字数达上限
      showUpdateDialog: false,
      locale: zhCN,
      selectSort: [],
      updateProjectData: {  //编辑项目信息
        projectId: '',
        category: '',
        note: '',
      },
      updateProjectUserData: {//更换用户
        projectId: '',
        selectedSalers: [],
        selectedAnalyze: '',
      },
      downloadUrl: '../',
      loadingProject: true,
      addProjectLock: false,
      projectPageChildMsg: {
        total: 0,
        pageSize: 8,
        currentNum: 1
      },
      projectDataPageparm: {
        currentNum: 1,
        pageSize: 8
      },
      project: {
        projectData: [],
      },
      columns: [
        {
          title: '项目号',
          dataIndex: 'projectsRow.projectId',
          key: 'projectId',
          sorter: true,
          sortDirections: ["descend", "ascend", "descend"],
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'customProject',
          },
        },
        {
          title: '密码',
          key: 'projectsRow.projectPassword',
          dataIndex: 'projectsRow.projectPassword',
          sortDirections: ["descend", "ascend", "descend"],
        },
        {
          title: '销售',
          dataIndex: 'saler.userName',
          key: 'saler.userName',
          customRender: (text, record) => {
            return (
              <span>
                {record.salesList.map((user, index) => (
                  <span key={index}>{user.userName}{index === record.salesList.length - 1 ? '' : '；'}</span>
                ))}
              </span>
            );
          },
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
          },
        },
        {
          title: '客户名称',
          dataIndex: 'customer.userName',
          key: 'customer.userName',
          customRender: (text, record) => {
            return (
              <span>
                {record.customerList.map((user, index) => (
                  <span key={user.userName}>{user.userName}{index === record.customerList.length - 1 ? '' : '；'}</span>
                ))}
              </span>
            );
          },
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
          },
        },
        {
          title: '分析人员',
          dataIndex: 'analyzer.userName',
          key: 'analyzer.userName',
          // sorter: true,
          sortDirections: ["descend", "ascend", "descend"],
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
          },
        },
        {
          title: '创建时间',
          dataIndex: 'projectsRow.createTime',
          key: 'projectsRow.createTime',
          sorter: true,
          sortDirections: ["descend", "ascend", "descend"],
          scopedSlots: {
            filterDropdown: 'time',
            filterIcon: 'filterIcon',
          },
        },
        {
          title: '类型',
          dataIndex: 'projectsRow.category',
          key: 'projectsRow.category',
          sorter: true,
          sortDirections: ["descend", "ascend", "descend"],
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'customCategory',
          },
        },
        {
          title: '合同号信息',
          dataIndex: 'projectsRow.contractNumber',
          key: 'projectsRow.contractNumber',
          sorter: true,
          sortDirections: ["descend", "ascend", "descend"],
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
          },
        },
        {
          title: '备注',
          dataIndex: 'projectsRow.note',
          key: 'projectsRow.note',
          sorter: true,
          width: 200,
          sortDirections: ["descend", "ascend", "descend"],
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'customNote',
          },
        },
        // {
        //   title: '原始数据状态',
        //   dataIndex: 'projectsRow.rawdataStatus',
        //   key: 'projectsRow.rawdataStatus',
        //   sorter: true,
        //   width: 200,
        //   sortDirections: ["descend", "ascend", "descend"],
        //   scopedSlots: {
        //     filterDropdown: 'filterType',
        //     filterIcon: 'filterIcon',
        //     customRender: 'rawdataStatus',
        //   },
        // },
        {
          title: '操作',
          key: 'operation',
          scopedSlots: {customRender: 'operation'},
        },
      ],
      sortList: '',
      analyzerList: [],//分析员列表
      salerList: [],//销售列表
    }

  },

  created() {
    this.handleUriParams()
  },
  mounted() {
    this.getProject()
  },
  methods: {
    //处理url的搜索条件，通过用户管理点击过来的
    handleUriParams() {
      var role = this.$route.query.role
      var id = this.$route.query.id
      var userName = this.$route.query.userName
      var roles = new Set(['saler', 'customer', 'analyzer'])
      if (role && id && roles.has(role)) {
        var identity = role == 'saler' ? '销售' : role == 'analyzer' ? '分析人员' : '客户'
        this.searchConditionTag.push({
          title: identity,
          key: 'userRoleAndId',
          value: userName,
          data: {
            'role': userTransUp(role),
            'id': id
          }
        })
      }
    },
    //获取项目列表
    async getProject() {
      var sendData = {
        pageNum: this.projectDataPageparm.currentNum,
        pageSize: this.projectDataPageparm.pageSize,
        projectId: this.projectId,
      }
      let length = this.searchConditionTag.length
      if (length) {
        sendData.search = {}
        this.searchConditionTag.forEach(item => {
          let key = item.key
          if (key === 'projectsRow.projectId') {
            sendData.search.projectId = item.value
          } else if (key === 'analyzer.userName') {
            sendData.search.analyzeName = item.value
          } else if (key === 'saler.userName') {
            sendData.search.saleName = item.value
          } else if (key === 'projectsRow.createTime') {
            let value = item.value
            let index = value.indexOf('至')
            let value1 = value.substring(0, index)
            let value2 = value.substring(index + 1, value.length)
            let time = [addT(value1), addT(value2)]
            sendData.search.createTime = time
          } else if (key === 'customer.userName') {
            sendData.search.customerName = item.value
          } else if (key === 'projectsRow.note') {
            sendData.search.note = item.value
          } else if (key === 'projectsRow.rawdataStatus') {
            if (item.value === '已释放') {
              sendData.search.rawdataStatus = 1
            } else {
              sendData.search.rawdataStatus = 0
            }
          } else if (key === 'projectsRow.contractNumber') {
            sendData.search.contractNumber = item.value
          } else if (key === 'userRoleAndId') {
            var userRoleAndId = item.data
            if (userRoleAndId.role === 'saler') {
              sendData.search.saleId = userRoleAndId.id
            } else if (userRoleAndId.role === 'analyzer') {
              sendData.search.analyzeId = userRoleAndId.id
            } else {
              sendData.search.customerId = userRoleAndId.id
            }
          } else {
            sendData.search.category = item.value
          }
        })
      } else {
        sendData.search = {}
      }
      sendData.sorts = this.selectSort
      const res = await this.$http.post('/project/page', sendData)
      this.loadingProject = false
      if (res) {
        if (res.code === 200) {
          var pageData = res.data
          this.project.projectData = pageData.data
          this.projectPageChildMsg.total = pageData.totalNum
          this.projectPageChildMsg.pageSize = pageData.pageSize
          this.projectPageChildMsg.currentNum = pageData.currentNum
        }
      }
    },
    //分页
    handlePagePagination(pageparm) {
      this.loadingProject = true
      this.projectDataPageparm = pageparm
      this.getProject()
    },
    //点击新建项目按钮
    showAddProjectDialog () {
      this.addProjectDialogVisible = true
    },
    //新建项目
    async addProject(sendData) {
      this.addProjectDialogVisible = false
      this.isShowAddLoading = true
      this.showAddLoadingMess = '项目新建中，请耐心等待'
      this.$http({
        method: 'post',
        url: 'project',
        data: sendData,
      }).then(res => {
        if (res.code === 200) {
          this.projectDataPageparm.currentNum = 1
          this.getProject()
          this.$messageUi.success('添加成功')
        } else {
          this.$messageUi.error(res.message)
        }
      })
        .catch(error => {
          this.$messageUi.error('添加失败')
          return
        })
        .finally(() => {
          this.isShowAddLoading = false
          this.addProjectLock = false
        })
    },
    // 导出项目列表
    async exportProjectInfo() {
      var that = this
      this.$store.commit('publicProgress/setShowPublicProgress', true)
      this.$store.commit('publicProgress/setPublicProgress', 0)
      await this.$http({
        url: "/project/export/all",
        responseType: "blob",
        onDownloadProgress: function (progressEvent) {
          if (progressEvent.lengthComputable) {
            that.$store.commit('publicProgress/setPublicProgress', progressEvent.loaded / progressEvent.total * 100)
          }
        }
      }).catch(error => {
        this.$messageUi.error("项目列表导出失败")
      }).then(res => {
        fileDownload(res.file, '项目信息表.xlsx')
        this.$store.commit('publicProgress/setShowPublicProgress', false)
      })

    },
    //根据备注的长度调整展示的内容
    computerNote (text) {
      if (text) {
        if (text.length <= 30) {
          return text
        } else {
          return text.substring(0, 30)
        }
      } else {
        return ''
      }
    },
    // 判断是否需要...展示
    showNote (text) {
      if (text) {
        return text.length > 30
      } else {
        return false
      }
    },
    //备注框的长度限制
    limitLength (value) {//value 为获取到的输入框的值
      this.exceedMax = value.length === 100
    },
    // 提交释放原始数据申请
    async releaseRowData(record) {
      const projectId = record.projectsRow.projectId
      const res = await this.$http.get("/project/verifyRawData/" + projectId)
      if (res) {
        if (res.code === 200) {
          this.getProject()
          this.$messageUi.success("释放成功")
        }
      }
    },
    //点击删除项目
    async handleDeleteProject(record) {
      const projectId = record.projectsRow.projectId
      let that = this
      this.$confirmUi('此操作将会永久删除该项目, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        that.deleteProject(projectId)
      }).catch(() => {
      })
    },
    // 删除请求
    async deleteProject(projectId) {
      const res = await this.$http.delete("project", {
        data: {projectId}
      }).catch(err => {
        this.$messageUi.error("删除失败")
      })
      if (res) {
        if (res.code === 200) {
          this.$messageUi.success("删除成功")
          const totalPage = Math.ceil((this.projectDataPageparm.total - 1) / this.projectDataPageparm.pageSize)
          this.projectDataPageparm.currentNum =this.projectDataPageparm.currentNum > totalPage ? totalPage : this.projectDataPageparm.currentNum
          this.projectDataPageparm.currentNum =this.projectDataPageparm.currentNum < 1 ? 1 : this.projectDataPageparm.currentNum
          await this.getProject()
        }
      }

    },
    // 点击更改用户
    handleEditProject(project) {
      this.updateProjectUserData.selectedAnalyze = project.analyzer.userId
      this.updateProjectUserData.selectedSalers = project.salesList.map(item => {
        return item.userId
      })
      this.updateProjectUserData.projectId = project.projectsRow.projectId
      this.getUserByRole('ANALYST').then(res=> {
        if(res.code===200){
          this.analyzerList = res.data
          this.showUserDialog = true
          this.getUserByRole('SALES').then(res2 => {
            if(res2.code===200){
              this.salerList = res2.data
            }
          })
        }

      })
    },
    //获取销售和分析列表
    async getUserByRole(role) {
      return new Promise((resolve, reject) => {
        this.$http.get('user/role/' + role).then(res=>{
          if (res) {
            if (res.code === 200) {
              resolve(res)
            }else {
              reject()
            }
          }
        }).catch(()=>{
          reject()
        })
      })
    },
    //提交更换用户
    updateProjectUser() {
      let sendData = {
        "projectId": this.updateProjectUserData.projectId,
        "analystId": this.updateProjectUserData.selectedAnalyze,
        "salesIds": this.updateProjectUserData.selectedSalers,
        "customerIds": []
      }
      if (this.updateProjectUserData.selectedSalers.length < 1) {
        this.$messageUi.error('至少选择一个销售')
        return
      }
      this.$http.put('/project/editUsers', sendData).then(res => {
        if (res) {
          if (res.code === 200) {
            this.$messageUi.success('修改成功')
            this.showUserDialog = false
            this.getProject()
          }
        }
      })
    },
    //点击修改备注
    editNote(project) {
      this.exceedMax = false
      project = project.projectsRow
      this.updateProjectData.projectId = project.projectId
      this.updateProjectData.category = project.category
      this.updateProjectData.note = project.note
      this.showNoteDialog = true
    },
    //点击修改项目类型
    handleShowUpdateDialog(project) {
      project = project.projectsRow
      this.updateProjectData.projectId = project.projectId
      this.updateProjectData.note = project.note
      this.updateProjectData.category = project.category
      this.showUpdateDialog = true
    },
    //提交项目信息的修改
    async updateProject() {
      const res = await this.$http.put('/project', this.updateProjectData)
      this.showUpdateDialog = false
      this.showNoteDialog = false
      if (res) {
        if (res.code == 200) {
          this.$messageUi.success('修改成功')
          this.getProject()
        } else {
          this.$messageUi.error('修改失败')
        }
      }
    },

    //进入具体的项目
    toProject (projectId) {
      this.$router.push('/analyze?projectId=' + projectId)
    },
    //mixin
    addLoading() {
      this.loadingProject = true
    },
    updatePageDataBySearch() {
      this.projectDataPageparm.currentNum = 1
      this.getProject()
    },
    updatePageData() {
      this.getProject()
    }
  }
}
</script>

<style scoped>
.show-simple-table {
  width: 80%;
  margin: 0 auto;
}

.show-simple-table tr {
  width: 100%;
}

.show-simple-table tr td {
  width: 25%;
  height: 40px;
  padding: 0;
  border: 1px solid black;
}

.show-simple-table, .show-simple-table td {
  border-collapse: collapse;
}

.el-breadcrumb {
  margin-bottom: 20px;
}

.btn-add {
  margin-bottom: 20px;
}

::v-deep .ant-table-empty .ant-table-body {
  overflow-x: visible !important;
  overflow-y: visible !important;
}

::v-deep .ant-table-body {
  overflow-x: auto !important;
}

::v-deep.ant-table td {
  white-space: nowrap;
}

addProject /deep/ .el-dialog__wrapper {
  overflow: hidden !important;
}

/*.addProject /deep/ .el-dialog {*/
/*  height: 600px !important;*/
/*  overflow-y: auto !important;*/
/*  overflow-x: auto !important;*/
/*  min-width: 600px;*/
/*}*/

</style>
